module.exports = __webpack_public_path__ + "img/宣化钻机.c7b5bf50.jpg";